var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { attachKey2click, Popup, ReactElementFactory, SvgIcon, SurveyElementBase } from "survey-react-ui";
import { ReactMouseEvent } from "./events";
var AddQuestionButtonComponent = /** @class */ (function (_super) {
    __extends(AddQuestionButtonComponent, _super);
    function AddQuestionButtonComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AddQuestionButtonComponent.prototype, "model", {
        get: function () {
            return this.props.item.data;
        },
        enumerable: false,
        configurable: true
    });
    AddQuestionButtonComponent.prototype.renderTypeSelector = function () {
        var questionTypeSelectorModel = this.model.questionTypeSelectorModel;
        return attachKey2click(React.createElement("button", { type: "button", onClick: function (e) {
                e.stopPropagation();
                questionTypeSelectorModel.action();
            }, className: "svc-element__question-type-selector", title: this.model.addNewQuestionText, role: "button" },
            React.createElement("span", { className: "svc-element__question-type-selector-icon" },
                React.createElement(SvgIcon, { iconName: questionTypeSelectorModel.iconName, size: "auto", title: this.model.addNewQuestionText })),
            this.props.renderPopup === undefined || this.props.renderPopup ?
                React.createElement(Popup, { model: questionTypeSelectorModel.popupModel })
                : null));
    };
    AddQuestionButtonComponent.prototype.renderElement = function () {
        var _this = this;
        var addButtonClass = this.props.buttonClass || "svc-btn";
        return React.createElement(React.Fragment, null,
            attachKey2click(React.createElement("div", { className: "svc-element__add-new-question " + addButtonClass, onClick: function (e) {
                    e.stopPropagation();
                    _this.model.addNewQuestion(_this.model, new ReactMouseEvent(e));
                }, onMouseOver: function (e) { return _this.model.hoverStopper && _this.model.hoverStopper(e.nativeEvent, e.currentTarget); } },
                React.createElement(SvgIcon, { className: "svc-panel__add-new-question-icon", iconName: "icon-add_24x24", size: "auto" }),
                React.createElement("span", { className: "svc-add-new-item-button__text" }, this.model.addNewQuestionText),
                this.props.renderPopup !== false ? this.renderTypeSelector() : null)),
            this.props.renderPopup === false ? this.renderTypeSelector() : null);
    };
    return AddQuestionButtonComponent;
}(SurveyElementBase));
export { AddQuestionButtonComponent };
ReactElementFactory.Instance.registerElement("svc-add-new-question-btn", function (props) {
    return React.createElement(AddQuestionButtonComponent, props);
});
